/* bios-chat-panel.js — collapsible bottom-left chat panel + Offer / Sell overlays.
   Contains initChatPanel (Tab/C key toggle, click-outside close, hides while
   product preview is visible), initOffer (offer form -> Firebase + /contact),
   and initSell (sell or consign form, multi-image upload + last-5-prices field).
   References window.isTouchDevice from bios-main.js. */
/* ══════════════════════════════════════════════════════════════════════════
   CHAT PANEL — collapsible bottom-left panel with [OFFER] [SELL] [CHAT]
   ══════════════════════════════════════════════════════════════════════════ */
(function initChatPanel() {
  var chatEl  = document.getElementById('bios-chat');
  if (!chatEl) return;

  /* ── Collapse / expand ── */
  function isExpanded() { return chatEl.classList.contains('is-expanded'); }
  function setExpanded(open) {
    if (!open && isExpanded()) {
      /* animate close: add is-closing, then strip is-expanded after animation */
      chatEl.classList.add('is-closing');
      setTimeout(function () { chatEl.classList.remove('is-expanded', 'is-closing'); }, 210);
      try { if (window.BiosAudio) window.BiosAudio.overlayClose(); } catch (_) {}
      return;
    }
    chatEl.classList.toggle('is-expanded', open);
    if (open) {
      try { if (window.BiosAudio) window.BiosAudio.overlayOpen(); } catch (_) {}
      var msgsEl = document.getElementById('bios-chatroom-msgs');
      if (msgsEl) setTimeout(function () { msgsEl.scrollTop = msgsEl.scrollHeight; }, 50);
    }
  }

  /* expose for external callers */
  window._biosOpenMarket = function() { setExpanded(true); };

  /* [CHAT] button toggles expand */
  var chatOpenBtn = document.getElementById('bios-chat-open-btn');
  if (chatOpenBtn) {
    chatOpenBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      setExpanded(!isExpanded());
    });
  }

  /* [OFFER] and [SELL] buttons stop propagation (handled by initOffer/initSell) */
  var offerOpenBtn = document.getElementById('bios-offer-open-btn');
  var sellOpenBtn  = document.getElementById('bios-sell-open-btn');
  if (offerOpenBtn) offerOpenBtn.addEventListener('click', function(e) { e.stopPropagation(); });
  if (sellOpenBtn)  sellOpenBtn.addEventListener('click',  function(e) { e.stopPropagation(); });

  /* Click anywhere outside the chat panel (and not on the [CHAT] toggle) to close it. */
  document.addEventListener('click', function(e) {
    if (!isExpanded()) return;
    if (chatEl.contains(e.target)) return;
    if (chatOpenBtn && chatOpenBtn.contains(e.target)) return;
    setExpanded(false);
  });

  /* ── Hide panel when product preview is visible (desktop only) ── */
  var previewEl = document.getElementById('bios-preview');
  if (previewEl) {
    new MutationObserver(function() {
      if (isTouchDevice) return;
      chatEl.classList.toggle('is-hidden', previewEl.classList.contains('is-visible'));
    }).observe(previewEl, { attributes: true, attributeFilter: ['class'] });
  }

  /* ── SYS_CART panel — extracted to assets/bios-cart.js (256KB limit) ── */

  /* ── Tab or C key toggles chat open/closed ── */
  document.addEventListener('keydown', function(e) {
    var tag = document.activeElement ? document.activeElement.tagName : '';
    if (tag === 'INPUT' || tag === 'TEXTAREA') return;
    if (e.key === 'Tab') {
      e.preventDefault();
      setExpanded(!isExpanded());
    } else if (e.key === 'c' || e.key === 'C') {
      if (e.ctrlKey || e.metaKey) return;
      setExpanded(!isExpanded());
    }
  });
})();

/* ── Offer overlay ─────────────────────────────────────────────────────────── */
(function initOffer() {
  var FIREBASE_URL = 'https://innocences-be2c5-default-rtdb.firebaseio.com';
  var overlay   = document.getElementById('bios-offer-overlay');
  var openBtn   = document.getElementById('bios-offer-open-btn');
  var closeBtn  = document.getElementById('bios-offer-close');
  var submitBtn = document.getElementById('bios-offer-submit');
  var statusEl  = document.getElementById('bios-offer-status');
  if (!overlay || !openBtn) return;

  function openOffer()  {
    overlay.style.display = 'flex';
    try { if (window.BiosAudio) window.BiosAudio.overlayOpen(); } catch (_) {}
  }
  function closeOffer() {
    overlay.style.display = 'none';
    resetForm();
    try { if (window.BiosAudio) window.BiosAudio.overlayClose(); } catch (_) {}
  }
  function resetForm() {
    overlay.querySelectorAll('.bios-sell-inp').forEach(function(el) { el.value = ''; });
    setStatus('');
    if (submitBtn) submitBtn.disabled = false;
  }
  function setStatus(msg, cls) {
    if (!statusEl) return;
    statusEl.textContent = msg;
    statusEl.className = 'bios-sell-status' + (cls ? ' ' + cls : '');
  }

  openBtn.addEventListener('click', function() { openOffer(); });
  if (closeBtn) closeBtn.addEventListener('click', closeOffer);
  overlay.addEventListener('click', function(e) { if (e.target === overlay) closeOffer(); });
  overlay.addEventListener('keydown', function(e) { e.stopPropagation(); });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.style.display !== 'none') closeOffer();
  });

  if (submitBtn) submitBtn.addEventListener('click', function() {
    var item    = (document.getElementById('of-item')    || {}).value || '';
    var amount  = (document.getElementById('of-amount')  || {}).value || '';
    var contact = (document.getElementById('of-contact') || {}).value || '';
    var note    = (document.getElementById('of-note')    || {}).value || '';

    if (!item.trim())    { setStatus('\u26a0 ITEM REQUIRED');    return; }
    if (!amount.trim())  { setStatus('\u26a0 OFFER REQUIRED');   return; }
    if (!contact.trim()) { setStatus('\u26a0 CONTACT REQUIRED'); return; }

    setStatus('\u25cf SENDING\u2026');
    submitBtn.disabled = true;

    var node = sessionStorage.getItem('bios_market_node') || 'ANON';
    var div  = '\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500';
    var body = [
      'NEW OFFER',
      div,
      'ITEM: '    + item.trim(),
      'OFFER: '   + amount.trim(),
      'CONTACT: ' + contact.trim(),
      'NOTE: '    + (note.trim() || '(none)'),
      'NODE: '    + node,
      'TIME: '    + new Date().toISOString(),
      div,
      'Submitted via INNOCENCES.'
    ].join('\n');

    /* Firebase log */
    fetch(FIREBASE_URL + '/offers.json', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ item: item.trim(), amount: amount.trim(), contact: contact.trim(), note: note.trim(), node: node, ts: Date.now() })
    }).catch(function(){});

    /* Email notification */
    fetch('/contact', {
      method:  'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body:    new URLSearchParams({
        'form_type':     'contact',
        'utf8':          '\u2713',
        'contact[name]': 'OFFER \u00b7 ' + item.trim(),
        'contact[email]':'myinnocences@gmail.com',
        'contact[body]': body
      })
    })
    .then(function(r) {
      if (!r.ok) throw new Error(r.status);
      setStatus('\u2713 OFFER SENT \u00b7 WE\'LL BE IN TOUCH', 'is-ok');
      overlay.querySelectorAll('.bios-sell-inp').forEach(function(el) { el.value = ''; });
    })
    .catch(function() {
      setStatus('\u26a0 SEND FAILED \u00b7 TRY AGAIN');
      submitBtn.disabled = false;
    });
  });
})();

/* ── Sell-to-us form ─────────────────────────────────────────────────────── */
(function initSell() {
  var overlay   = document.getElementById('bios-sell-overlay');
  var closeBtn  = document.getElementById('bios-sell-close');
  var submitBtn = document.getElementById('bios-sell-submit');
  var statusEl  = document.getElementById('bios-sell-status');
  var openBtn   = document.getElementById('bios-sell-open-btn');
  if (!overlay || !openBtn) return;

  function openSell()  {
    overlay.style.display = 'flex';
    try { if (window.BiosAudio) window.BiosAudio.overlayOpen(); } catch (_) {}
  }
  function closeSell() {
    overlay.style.display = 'none';
    resetForm();
    try { if (window.BiosAudio) window.BiosAudio.overlayClose(); } catch (_) {}
  }

  function resetForm() {
    overlay.querySelectorAll('.bios-sell-inp').forEach(function(el) { el.value = ''; });
    setStatus('');
    if (submitBtn) submitBtn.disabled = false;
  }

  function setStatus(msg, cls) {
    if (!statusEl) return;
    statusEl.textContent = msg;
    statusEl.className = 'bios-sell-status' + (cls ? ' ' + cls : '');
  }

  openBtn.addEventListener('click', function(e) {
    e.stopPropagation(); /* don't toggle the market panel */
    openSell();
  });
  if (closeBtn) closeBtn.addEventListener('click', closeSell);

  /* ── Sell / Consign tab switching ── */
  var sellTabBtns = overlay.querySelectorAll('.bios-sell-mode-tab');
  sellTabBtns.forEach(function(tab) {
    tab.addEventListener('click', function() {
      var mode = tab.dataset.mode;
      sellTabBtns.forEach(function(t) { t.classList.toggle('is-active', t === tab); });
      var modeEl = document.getElementById('sf-mode');
      if (modeEl) modeEl.value = mode;
      var noteS = document.getElementById('bios-sell-note-sell');
      var noteC = document.getElementById('bios-sell-note-consign');
      if (noteS) noteS.style.display = mode === 'sell' ? '' : 'none';
      if (noteC) noteC.style.display = mode === 'consign' ? '' : 'none';
      if (submitBtn) submitBtn.textContent = mode === 'consign' ? '[ SEND CONSIGNMENT ]' : '[ SEND LISTING ]';
      var ttl = document.getElementById('bios-sell-ttl');
      if (ttl) ttl.textContent = mode === 'consign' ? 'CONSIGN \u00b7 70/30 SPLIT' : 'TO INNOCENCES';
    });
  });
  overlay.addEventListener('click', function(e) { if (e.target === overlay) closeSell(); });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.style.display !== 'none') closeSell();
  });

  /* ── Stop drum-scroll keys firing while sell form is open ── */
  overlay.addEventListener('keydown', function(e) { e.stopPropagation(); });

  if (submitBtn) submitBtn.addEventListener('click', function() {
    var email  = (document.getElementById('sf-email')  || {}).value || '';
    var name   = (document.getElementById('sf-name')   || {}).value || '';
    var asking = (document.getElementById('sf-asking') || {}).value || '';
    var notes  = (document.getElementById('sf-notes')  || {}).value || '';

    /* collect price rows */
    var priceRows  = overlay.querySelectorAll('.bios-sell-price-row');
    var pricesData = [];
    priceRows.forEach(function(row) {
      var pv = (row.querySelector('.bios-sell-price') || {}).value || '';
      var uv = (row.querySelector('.bios-sell-url')   || {}).value || '';
      if (pv.trim() || uv.trim()) pricesData.push({ price: pv.trim(), url: uv.trim() });
    });

    /* collect image URLs */
    var imgUrls = [];
    overlay.querySelectorAll('.sf-img').forEach(function(el) {
      if (el.value.trim()) imgUrls.push(el.value.trim());
    });

    /* validate */
    if (!email.trim())     { setStatus('\u26a0 EMAIL REQUIRED');              return; }
    if (!name.trim())      { setStatus('\u26a0 ITEM NAME REQUIRED');          return; }
    if (!pricesData.length){ setStatus('\u26a0 ADD AT LEAST 1 SOLD PRICE');  return; }
    if (!imgUrls.length)   { setStatus('\u26a0 ADD AT LEAST 1 IMAGE URL');   return; }
    if (!asking.trim())    { setStatus('\u26a0 ASKING PRICE REQUIRED');       return; }

    setStatus('\u25cf SENDING\u2026');
    submitBtn.disabled = true;

    /* build email body */
    var sfMode = (document.getElementById('sf-mode') || {}).value || 'sell';
    var div = '\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500';
    var body = [
      sfMode === 'consign' ? 'CONSIGNMENT SUBMISSION \u00b7 70% SELLER / 30% INNOCENCES' : 'SELL SUBMISSION',
      div,
      'FROM: '          + email.trim(),
      'ITEM: '          + name.trim(),
      'ASKING PRICE: '  + asking.trim(),
      div,
      'LAST 5 SOLD PRICES:'
    ].concat(pricesData.map(function(p, i) {
      return '  [' + (i + 1) + '] ' + p.price + (p.url ? '  \u00b7  ' + p.url : '');
    })).concat([
      div,
      'IMAGES:'
    ]).concat(imgUrls.map(function(u, i) {
      return '  [' + (i + 1) + '] ' + u;
    })).concat([
      div,
      'NOTES:',
      notes.trim() || '(none)',
      div,
      'Submitted via INNOCENCES \u00b7 ' + new Date().toISOString()
    ]).join('\n');

    fetch('/contact', {
      method:  'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body:    new URLSearchParams({
        'form_type':     'contact',
        'utf8':          '\u2713',
        'contact[name]': (sfMode === 'consign' ? 'CONSIGN' : 'SELL') + ' \u00b7 ' + name.trim(),
        'contact[email]':'myinnocences@gmail.com',
        'contact[body]': body
      })
    })
    .then(function(r) {
      if (!r.ok) throw new Error(r.status);
      setStatus('\u2713 RECEIVED \u00b7 WILL REVIEW WITHIN 48H', 'is-ok');
      overlay.querySelectorAll('.bios-sell-inp').forEach(function(el) { el.value = ''; });
    })
    .catch(function() {
      setStatus('\u26a0 SEND FAILED \u00b7 TRY AGAIN');
      submitBtn.disabled = false;
    });
  });
})();

/* Load choreography extracted to assets/bios-load-mixer.js (256KB limit). */
